import React from 'react'
import { useCourseReport } from '../../context/CourseReportContext'
import { useUserReport } from '../../context/UserReportContext'
import { GetCourseData } from '../CourseContentData'
import { ColumnDef } from '@tanstack/react-table'
import TableCheckbox from '../../../../../common/checkbox/TableCheckbox'
import { CourseQuizDetailsReport } from '../../types/courseDetails'
import TanstackContent from '../../../Table/Tanstack/TanstackContent'
import { getExportHeaders } from '../../types/tableHeaders'
import Question from '../../../../../common/question/Question'

/**
 * Quiz Details includes the table of questions and answers of the user based on Quiz
 */
const QuizDetails = ({ from }) => {

    const { selectedQuiz, userDatum, courseDetails, selectedUser } = from === 'course-report' ? useCourseReport() : useUserReport()
    const [rowSelection, setRowSelection] = React.useState({})
    const [globalFilter, setGlobalFilter] = React.useState('')
    const [data, setData] = React.useState(() => GetCourseData( selectedQuiz, selectedUser, 'quiz-details', userDatum ) )

    React.useEffect(() => {
        setData(() => GetCourseData( selectedQuiz, selectedUser, 'quiz-details' , userDatum ))
    }, [ selectedQuiz ])

    const columns = React.useMemo<ColumnDef<CourseQuizDetailsReport>[]>(
        () => [
          {
            id: 'columns',
            columns: [
              {
                id: 'quizId',
                accessorKey: 'quizId',
                prettyName: 'Quiz ID',
                show: false,
                cell: info => info.getValue(),
                header: () => <span>QUIZ ID</span>,
              },
              {
                id: 'quizQuestion',
                accessorKey: 'quizQuestion',
                prettyName: 'Question',
                cell: info => (
                  <Question info={info} from={from} />
                ),
                footer: props => props.column.id,
                header: () => <span>QUESTION</span>,
              },
              {
                id: 'quizPoints',
                accessorKey: 'quizPoints',
                prettyName: 'Points',
                cell: info => info.getValue(),
                footer: props => props.column.id,
                header: () => <span>POINTS</span>,
              },
              {
                id: 'quizCorrect',
                accessorKey: 'quizCorrect',
                prettyName: 'CORRECT COUNT',
                cell: info => info.getValue(),
                footer: props => props.column.id,
                header: () => <span>CORRECT</span>,
              },
              {
                id: 'quizIncorrect',
                accessorKey: 'quizIncorrect',
                prettyName: 'INCORRECT COUNT',
                cell: info => info.getValue(),
                footer: props => props.column.id,
                header: () => <span>INCORRECT COUNT</span>,
              },
              {
                id: 'quizPointsScored',
                accessorKey: 'quizPointsScored',
                prettyName: 'POINTS SCORED',
                cell: info => info.getValue(),
                footer: props => props.column.id,
                header: () => <span>POINTS SCORED</span>,
              }
            ],
          }
        ],
    []
    )

    const exportHeaders = getExportHeaders( 'quiz-details' )
  
    return (
        <TanstackContent
          data={data}
          columns={columns}
          rowSelection={rowSelection}
          setRowSelection={setRowSelection}
          sorting={null}
          setSorting={null}
          globalFilter={globalFilter}
          setGlobalFilter={setGlobalFilter}
          filterType={'course-content-filter'}
          children={null}
          exportHeaders={exportHeaders}
          from={'Quiz Detailed Report'}
          context={ from === 'course-report' ? 'Courses' : 'Users' }
          hideFilters={true}
          columnFilters={ null }
          setColumnFilters={ null }
        />
      )
}

export default QuizDetails
